import { parseJSON, isValid } from 'date-fns';
import { logger } from '../../utilities/logger';
import { useTokenContext } from '../../contexts/token/use_token_context';
import { useCustomEventListener } from '../../hooks/use_custom_event_listener';

export const POST_TOKEN_EVENT_KEY = 'postToken';

export const usePostToken = () => {
  const { setToken, setExpiry } = useTokenContext();

  useCustomEventListener(POST_TOKEN_EVENT_KEY, (event) => {
    logger.debug({
      message: `${POST_TOKEN_EVENT_KEY} event received`,
      extra: { detail: event.detail },
    });
    const expireDate = parseJSON(event.detail.expire);

    if (event.detail.token === '' || event.detail.token === 'null') {
      logger.error({
        error: new Error('Invalid token received'),
        message: 'Invalid token received',
        extra: { token: event.detail.token },
      });
      return;
    }

    if (!isValid(expireDate)) {
      logger.error({
        error: new Error('Invalid date format received'),
        message: 'Invalid date received',
        extra: { expire: event.detail.expire },
      });
      return;
    }

    setToken(event.detail.token);
    setExpiry(expireDate);
  });
};
